/**
 * Jewellery permission keys (catalog `jewel.*`, docs/contracts/jewellery.md §5). The UI hides what a key does not allow;
 * the API checks the same keys.
 */
export const jewelPermissions = {
  moduleView: "jewel.jewellery.view",
  saleView: "jewel.sale.view",
  saleCreate: "jewel.sale.create",
  saleUpdate: "jewel.sale.update",
  salePost: "jewel.sale.post",
  saleDelete: "jewel.sale.delete",
  salePrint: "jewel.sale.print",
  buyBackView: "jewel.purchase.view",
  buyBackCreate: "jewel.purchase.create",
  buyBackUpdate: "jewel.purchase.update",
  buyBackPost: "jewel.purchase.post",
  buyBackDelete: "jewel.purchase.delete",
  itemView: "jewel.item.view",
  itemCreate: "jewel.item.create",
  itemUpdate: "jewel.item.update",
  itemDelete: "jewel.item.delete",
  tagView: "jewel.tag.view",
  tagCreate: "jewel.tag.create",
  tagUpdate: "jewel.tag.update",
  tagDelete: "jewel.tag.delete",
  accountView: "jewel.gold_account.view",
  accountCreate: "jewel.gold_account.create",
  accountUpdate: "jewel.gold_account.update",
  accountPost: "jewel.gold_account.post",
  accountDelete: "jewel.gold_account.delete",
  accountReverse: "jewel.gold_account.reverse",
  wagesView: "jewel.salesperson.view",
  wagesCreate: "jewel.salesperson.create",
  wagesPost: "jewel.salesperson.post",
  wagesDelete: "jewel.salesperson.delete",
  wagesReverse: "jewel.salesperson.reverse",
  refiningView: "jewel.refining.view",
  refiningCreate: "jewel.refining.create",
  refiningPost: "jewel.refining.post",
  refiningDelete: "jewel.refining.delete",
  priceView: "jewel.price.view",
  priceCreate: "jewel.price.create",
  priceUpdate: "jewel.price.update",
  priceDelete: "jewel.price.delete",
  karatView: "jewel.karat.view",
  karatCreate: "jewel.karat.create",
  karatUpdate: "jewel.karat.update",
  karatDelete: "jewel.karat.delete",
  reportView: "jewel.report.view",
  settingsView: "jewel.settings.view",
} as const;

/** Plan module of the jewellery screens (P6). */
export const jewelModule = "jewellery";

/** Settings page group of the jewellery settings. */
export const jewelSettingsGroup = "jewel";
